import React from 'react';
// Constants
import { CompanyName, KeywordsPages } from '../../utils/Constants';
// Data
import {
  indexPageAdditionalMeta,
  indexPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import { HelmetItem } from '../../components/utils/HelmetItem';
import IndexPageMainContainer from '../../components/index/IndexPageMainContainer';

const IndexPage = React.memo(() => {
  return (
    <>
      <HelmetItem
        PageName='Your new god!'
        desc={`Enter the realm of ${CompanyName}, where dominance, seduction, and surrender intertwine. Discover My mastery, desires, and the unforgettable experiences that await you.`}
        keywords={KeywordsPages}
        additionalMeta={indexPageAdditionalMeta}
        structuredData={indexPageStructuredData}
      />
      {/* Page */}
      <div className='grid min-h-screen h-dvh lg:h-screen max-h-screen overflow-hidden bg-colour2 font-poppins py-6 px-6'>
        <div className='grid neon-border border-2 border-solid border-colour1 w-full h-full bg-colour2/20'>
          {/* Main page content */}
          <IndexPageMainContainer />
        </div>
      </div>
    </>
  );
});

export default IndexPage;
